__webpack_require__.p = "https://static-basket-02.wbbasket.ru/vol20/appeal-copyright-front/latest/_next/";